var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.843 0.00998394C20.8922 0.680641 19.8395 1.19359 18.7254 1.52906C18.1274 0.841518 17.3327 0.354202 16.4488 0.133026C15.5649 -0.0881503 14.6343 -0.0325149 13.783 0.292407C12.9317 0.617329 12.2007 1.19586 11.689 1.94976C11.1772 2.70365 10.9093 3.59654 10.9215 4.50765V5.50052C9.17667 5.54576 7.44774 5.15879 5.88868 4.37406C4.32962 3.58933 2.98883 2.43122 1.98573 1.00285C1.98573 1.00285 -1.98573 9.93862 6.95004 13.9101C4.90527 15.2981 2.46941 15.994 0 15.8958C8.93577 20.8601 19.8573 15.8958 19.8573 4.47787C19.8563 4.20131 19.8298 3.92543 19.7778 3.65379C20.7912 2.65447 21.5062 1.39276 21.843 0.00998394Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.966e0fb6.svg";
export { ForwardRef as ReactComponent };